import React from 'react';
import {SkeletonStyleProps, StyledSkeleton} from './styled';

const Skeleton: React.FC<SkeletonStyleProps> = ({
	$height,
	$width,
	$dark = false,
}) => {
	return (
		<StyledSkeleton
			{...($width !== undefined ? {$width} : {})}
			{...($height !== undefined ? {$height} : {})}
			$dark={$dark}
		/>
	);
}

export default Skeleton;